module.exports = __webpack_public_path__ + "static/media/ae-unscratched.9b8396c4.png";